import React from 'react';
import Logo from '../images/icons/footerLogo.svg'
import ig from '../images/icons/ig.svg'
import x from '../images/icons/x.svg'
import tiktok from '../images/icons/tiktok.svg'
import fb from '../images/icons/fb.svg'
import location from '../images/icons/location.svg'
import phone from '../images/icons/phone.svg'
import email from '../images/icons/email.svg'
import dot from '../images/icons/dot.svg'
import { Link } from 'react-router-dom';

function Footer(props) {
    return (
        <div className='px-5 lg:px-20 mb-5 lg:mb-10'>
            <div className='bg-[#000000] rounded-[8px] items-center'>
                <div className='flex flex-col lg:flex-row lg:space-x-20 p-3 space-y-6 lg:space-y-0 lg:p-5 lg:py-10 lg:items-center'>
                    <div className='flex flex-col text-white text-start space-y-7 lg:w-[50%]'>
                        <div className=''><img className='w-[20%] lg-w-full' src={Logo} /></div>
                        <div className='text-[24px] lg:text-[32px] leading-[31px] lg:leading-[41.92px]'>Offering you the best recommendation system digitally</div>
                        <div className='flex flex-row space-x-3'>
                            <Link to="https://www.instagram.com/yebokenny_app"><img src={ig} /></Link>
                            <Link to="https://x.com/YeboKenny"><img src={x} /></Link>
                            <Link to="https://www.tiktok.com/@yebokenny3"><img src={tiktok} /></Link>
                            <Link to="https://www.facebook.com/yebokenny/"><img src={fb} /></Link>
                        </div>
                    </div>
                    <div className='flex flex-col text-white lg:space-y-2'>
                        <div className='font-[500] mb-4 text-start'>Quick Links</div>
                        <div className='flex flex-col text-start'>
                            <ul className='flex flex-col space-y-4'>
                                <Link to='/about'>About</Link>
                                <Link to='/pricing'>Pricing</Link>
                                <Link to='/contact'>Contact</Link>
                                <Link to='/faqs'>Faqs</Link>
                                <Link to='/blogs'>Blogs</Link>
                            </ul>
                        </div>
                    </div>
                    <div className='flex flex-col text-white space-y-2'>
                        <div className='font-[500] text-start mb-4'>Contact</div>
                        <div className='flex flex-col text-start'>
                            <ul className='flex flex-col space-y-4'>
                                <span className='flex flex-row space-x-2'>
                                    <span><img src={location} /></span>
                                    <span>Pietermaritzburg</span>
                                </span>
                                <span className='flex flex-row space-x-2'>
                                    <span><img src={phone} /></span>
                                    <span>+27 33 492 0174</span>
                                </span>
                                <span className='flex flex-row space-x-2'>
                                    <span><img src={email} /></span>
                                    <span>business@yebokenny.com</span>
                                </span>
                                <span className='flex flex-row space-x-2 text-black'>
                                    <span><img src='' /></span>
                                    <span>+27 33 492 0174</span>
                                </span>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='pb-5 px-5'>
                    <hr className='h-[1px]'></hr>
                </div>
                <div className='px-5 flex flex-col lg:flex-row text-start justify-between space-y-3 lg:space-y-0 text-white lg:items-center pb-8'>
                    <span>©YeboKenny. Positive Referencing for Business Excellence</span>
                    <div className='flex flex-row space-x-3 items-center'>
                        <Link to='/privacy-policy'>Privacy Policy</Link>
                        <span><img src={dot} /></span>
                        <Link to='/terms-and-conditions'>Terms and Conditions</Link>
                        <span><img src={dot} /></span>
                        <Link to='/cookies-policy'>Cookies Policy</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;